<agr-form-dialog [formGroup]="formGroup" [data]="data" (confirm)="confirm()" (cancel)="cancel()" class="flex--gutter-container">
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'year' | translate }}</mat-label>
      <mat-select formControlName="calendarYear" placeholder="{{ 'year' | translate }}" data-test="edit-fertilizer-type">
        @for (option of years; track option) {
          <mat-option [value]="option">
            {{ option }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'salesOrderPeriod' | translate }} </mat-label>
      <mat-select formControlName="salesOrderPeriodId" data-test="edit-sales-order-period" [placeholder]="'salesOrderPeriod' | translate">
        @for (option of filteredSalesOrderPeriods$ | async; track option) {
          <mat-option [value]="option.id">
            {{ option.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'fertilizerType' | translate }}</mat-label>
      <mat-select formControlName="fertilizerType" placeholder="{{ 'fertilizerType' | translate }}" data-test="edit-fertilizer-type">
        @for (option of filteredFertilizerTypes$ | async; track option) {
          <mat-option [value]="option">
            {{ option | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'cropAid' | translate }}</mat-label>
      <input
        type="text"
        matInput
        placeholder="{{ 'cropAid' | translate }}"
        formControlName="cropAidId"
        data-test="edit-crop-aid-id"
        [matAutocomplete]="cropAidAutocomplete"
      />
      <mat-autocomplete #cropAidAutocomplete="matAutocomplete" [displayWith]="displayCropAid()">
        @for (option of filteredCropAids$ | async; track option) {
          <mat-option [value]="option.id" data-test="edit-crop-aid-option">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'soilType' | translate }}</mat-label>
      <mat-select formControlName="soilTypeId" placeholder="{{ 'soilType' | translate }}" data-test="edit-soilType-name">
        @for (soilType of soilTypes; track soilType) {
          <mat-option [value]="soilType.id">
            {{ soilType.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'legalNitrogenWorkingCoefficient' | translate }}</mat-label>
      <input
        type="number"
        matInput
        placeholder="{{ 'legalNitrogenWorkingCoefficient' | translate }}"
        formControlName="nitrogenWorkingCoefficient"
        data-test="edit-nitrogen-working-coefficient"
      />
    </mat-form-field>
  </div>
</agr-form-dialog>
